import { TranslationService } from 'app/services/translation.service';
import { Component, OnDestroy, OnInit, PipeTransform } from '@angular/core';
import {EmailAccount} from '../../entities/EmailAccount';
import {LoginService} from '../../services/login.service';
import {ActivatedRoute, Router} from '@angular/router';
import {EmailAccountService} from 'app/services/email-account.service';
import {SalesPersonService} from '../../services/sales-person.service';
import {ConfigService} from '../../services/config.service';
import {JobService} from '../../services/job.service';
import {SessionService} from '../../services/session.service';
import {environment} from '../../../environments/environment';
import {ConnectionService} from '../../services/connection.service';
import {AppConfig} from '../../app.config';
import { Translation } from 'app/entities/Translation';
import { Subscription } from 'rxjs';
import { AzureLogin } from 'app/entities/AzureLogin';
import { TranslationPipe } from 'app/pipes/TranslationPipe';
import { EntraLoginManager } from '../../managers/entra-login.manager';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {

  constructor(private loginService: LoginService, private accoutService: EmailAccountService, private salesPersonService: SalesPersonService,
              private router: Router, private route: ActivatedRoute, private configService: ConfigService, private jobService: JobService,
              private sessionService: SessionService, private config: AppConfig, private translationService: TranslationService, private translationPipe: TranslationPipe,
              private entraLoginManager: EntraLoginManager) {
  }

  feedback: { access_token: string };
  errormsg: string;
  returnUrl: string;
  loginInUser: boolean = false;
  uniqueState: string;
  isLoading: boolean;
  solution: string = this.config.getConfig("solution");
  languages: string[];
  language: string;
  selectedLanguage: string;
  translations: Map<string, Translation>;
  getTranslationDataSub: Subscription;
  getLanguagesSub: Subscription;
  translationsLoaded: boolean = false;
  
  private emailAccount: EmailAccount;

  companies: any[];
  selectedCompany = '';

  ngOnInit() {
    this.emailAccount = new EmailAccount();

    this.language = this.getLanguageFromURL(this.route);
    this.selectedLanguage = this.getLanguageFromURL(this.route);
    
    this.getCompanies();
    this.setLastLoggedInUser();


    this.route.queryParams.subscribe(qParams => {
      this.returnUrl = qParams['returnUrl'] || '';
    });

    // new 270919
    this.route.params.subscribe(params => {
      let directLoginUsername = params['username'];
      let directLoginPassword = params['password'];
      let directJobNo = params['jobno'];
      // NM 021120 - Login directly with company >>
      // Works in url: ÆliteøTå%20514%20A%2FS
      // Works at api?: %C6lite%D8T%C5%20514%20A%2FS
      let directCompany = params['company'];
      // NM 021120 - Login directly with company >>


      if (!!directJobNo) {
        this.jobService.GetJob(directJobNo).subscribe(x => {
          this.configService.changeJob(x);
        });
      }

      if (!!directLoginUsername && !!directLoginPassword) {

        this.emailAccount.username = directLoginUsername;
        this.emailAccount.password = directLoginPassword;


        if (!!directCompany) {
          this.loginWithUrlCompany(directCompany);
        } else {
          this.loginWithCredentials(Object.assign({}, this.emailAccount));
        }

      }
    });

    this.getLanguagesSub = this.translationService.getLanguages(this.solution).subscribe(languages => {
      this.languages = languages;

      }, error => console.log(error));

    this.translationService.language.subscribe(language => {
      this.language = language;
    }, error => console.log(error));
    
    this.setTranslations(this.language)
    this.verifyUserIfCodeInUrl();
  }

  ngOnDestroy(){
    this.getLanguagesSub.unsubscribe();
  }


  getCompanies() {
    this.loginService.getCompanies().subscribe(x => {
      this.companies = x;
      this.selectedCompany = this.sessionService.getSelectedCompany() != null ? this.sessionService.getSelectedCompany() : ''
    });

  }

  setLastLoggedInUser() {
    this.emailAccount.username = this.loginService.getLoggedInUserID();
  }

  setSelectedCompany(company_part_url) {
    this.selectedCompany = company_part_url;
    this.sessionService.setSelectedCompany(company_part_url);
    this.sessionService.setCompanyType(this.companies.find(x => x.Company_Part_URL === company_part_url).Company_Type)
  }

  loginWithUrlCompany(company) {
    this.loginService.getCompanies().subscribe(x => {
      let companyObject = x.find(y => y.Company_Name === company);
      this.selectedCompany = companyObject.Company_Part_URL;
      this.sessionService.setSelectedCompany(this.selectedCompany);
      this.loginWithCredentials(Object.assign({}, this.emailAccount));
    });


  }


  loginWithCredentials(emailAccount: EmailAccount) {
    this.loginInUser = true;
    this.loginService.login(emailAccount).subscribe(() => {
        this.loginService.setSession(false).subscribe(() => this.finishLogin());
      }, (err) => {
        this.errormsg = this.translationPipe.transform('LoginErrorMessage');
        this.loginInUser = false;
      });
  };

  async LogInWithAzureAdAccount() {
    this.loginInUser = true;
    this.isLoading = true;

    const redirectUri = this.entraLoginManager.getEntraRedirectUri(this.language);
    const loginEndpoint = this.entraLoginManager.getEntraLoginEndpoint();
    const clientId = this.entraLoginManager.getClientId();
    const scope = this.entraLoginManager.getEntraScope();

    const state = this.entraLoginManager.randomString(32, 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789');
    const codeVerifier = this.entraLoginManager.randomString(128, 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~');
    const codeChallenge = await this.entraLoginManager.createCodeChallenge(codeVerifier);

    this.entraLoginManager.saveCodeVerifier(state, codeVerifier);
    window.location.href = this.entraLoginManager.buildAuthorizationUrl(loginEndpoint, clientId, redirectUri, scope, state, codeChallenge);
  }

  verifyUserIfCodeInUrl() {
    this.route.queryParams.subscribe(params => {
        let code = params['code'];
      if (!!code) {
        let state = params['state'];
        let codeVerifier = this.entraLoginManager.getCodeVerifier(state);
        if (!codeVerifier) {
          this.errormsg = 'Der kunne ikke findes en gyldig login-session. Prøv igen.';
          this.loginInUser = false;
          this.isLoading = false;
          return;
        }

        this.isLoading = true;

        let tokenRequest = {
          client_id: this.entraLoginManager.getClientId(),
          code: code,
          code_verifier: codeVerifier,
          redirect_uri: this.entraLoginManager.getEntraRedirectUri(this.language)
        };

        this.loginService.exchangeAuthorizationCodeForToken(this.entraLoginManager.getEntraTokenEndpoint(), tokenRequest).subscribe(tokenResponse => {
          let accessToken = tokenResponse && tokenResponse.access_token;
          if (!accessToken) {
            this.errormsg = 'Kunne ikke hente adgangstoken fra Microsoft.';
            this.loginInUser = false;
            this.isLoading = false;
            return;
          }

          this.loginService.getSalesPersonNoFromEntraToken(accessToken).subscribe(userNo => {
            this.salesPersonService.getIsEplannerAdmin(userNo).subscribe(isAdmin => {
              this.loginService.feedback = { access_token: accessToken };
              this.loginService.userNo = userNo;
              this.loginService.loggedSubject.next(true);
              this.loginService.setSession(isAdmin).subscribe(x => {
                this.finishLogin(state);
              });
            }, () => {
              this.errormsg = 'Kunne ikke finde brugeren i systemet.';
              this.loginInUser = false;
              this.isLoading = false;
            });
          }, () => {
            this.errormsg = 'Kunne ikke identificere brugeren ud fra Microsoft-login.';
            this.loginInUser = false;
            this.isLoading = false;
          });
        }, () => {
          this.errormsg = 'Kunne ikke validere Microsoft-login.';
          this.loginInUser = false;
          this.isLoading = false;
        });
        this.entraLoginManager.resetLoginUrl(this.language);
      }
    });
  }

  finishLogin(state?: string) {
    if (state) {
      this.entraLoginManager.clearCodeVerifier(state);
    }

    this.loginInUser = false;
    this.isLoading = false;
    this.entraLoginManager.resetLoginUrl(this.language);
    this.router.navigateByUrl(this.entraLoginManager.getPostLoginRedirectUrl(this.returnUrl, this.language));
  }

  getLanguageFromURL(route: ActivatedRoute): string{
    return route.snapshot.params.language
  }
   
  /**
   *Set the url with the language parameter and then reloads after a set amount of time
   * @param {string} language
   * @memberof LoginComponent
   */
  changeLanguage(language: string){
    this.language = language
    this.translationService.setLanguage(this.language);
    this.router.navigateByUrl(this.language + '/login')
    this.setTranslations(language);
    this.translationService.getLanguages(this.solution).do((languages) => {
      this.languages = languages;
    }).take(1).subscribe();
    setTimeout(() => {
      window.location.reload();
    }, 200)
  }

  setTranslations(language: string) {
    this.translationService.setTranslations(language);
    this.translationService.translationsSub.subscribe(translations => {
      this.translations = translations;
      // Get translations from the service 
      if (translations && Object.keys(translations).length > 0) {
        // Check to make sure that translations is loaded and in the correct language
        this.translationService.getLanguageSubject().subscribe(language => {
          // This check is done to only set translationsLoaded if the language in the translation object matches the active language. Sometimes it returns the old language object as the first call
          if (language == translations[Object.keys(translations)[0]].Language_Code) {
            this.translationsLoaded = true
          }
        })
      }
    })
  }

  //https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=6731de76-14a6-49ae-97bc-6eba6914391e&response_type=code&redirect_uri=http%3A%2F%2Flocalhost%2Fmyapp%2F&response_mode=query&scope=openid%20offline_access%20https%3A%2F%2Fgraph.microsoft.com%2Fmail.read&state=12345
  //this.snackBar.open("Du er logget ind.", "Ok", {
  //duration: 3000,
  //});
}





// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/login/login.component.ts